import { render } from "./CampaignsForm.vue?vue&type=template&id=6d34cef6"
import script from "./CampaignsForm.vue?vue&type=script&lang=js"
export * from "./CampaignsForm.vue?vue&type=script&lang=js"

import "./CampaignsForm.vue?vue&type=style&index=0&id=6d34cef6&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__